import {useNavigate} from "react-router-dom";
import {useBaseUrlCreateFlow} from "../../../services/urlServices";

export default function useFormSubmit(data){
    const navigateTo = useNavigate();
    const baseUrl = useBaseUrlCreateFlow();
    
    return function(data){
        console.log('new emp confirmation',data);
        navigateTo(`${baseUrl}/step2/credentials`);
    }
}
